//=================================================================================================
// SCRIPTING
//=================================================================================================

<script>
import Vue       from 'vue';
import Component from 'vue-class-component';

@Component({
	props : {
		text  : String,
		shown : {
			type    : Boolean,
			default : false,
		},
	},
})
export default class Tooltip extends Vue {
	favourited = false;

	toggleFavourite () {
		this.favourited = !this.favourited;
	}
}
</script>

//=================================================================================================
// TEMPLATING
//=================================================================================================

<template>
<span :class="{ shown }" class="tooltip-text">{{ text }}</span>
</template>

//=================================================================================================
// STYLING
//=================================================================================================

<style lang="scss" scoped>
@import '../assets/scss/colour.scss';

.tooltip-text {
	z-index                     : 1;
	position                    : absolute;
	width                       : 120px;
	padding                     : 5px 3px;
	border-radius               : 4px;
	color                       : black;
	background-color            : white;
	text-align                  : center;
	opacity                     : 0.0;
	transition                  : opacity 0.25s;
	bottom                      : 100%;
	margin-bottom               : 10px;
	left                        : 50%;
	margin-left                 : -60px;
	user-select                 : none;
	pointer-events              : none;

	&.shown {
		opacity                     : 1.0;
	}

	&::after {
		content                 : " ";
		position                : absolute;
		top                     : 100%; /* At the bottom of the tooltip */
		left                    : 50%;
		margin-left             : -5px;
		border-width            : 5px;
		border-style            : solid;
		border-color            : white transparent transparent transparent;
	}
}
</style>
